import { useEffect, useRef, useState, useMemo } from 'react';
import ScrollListener from '../../events/ScrollListener';
/**
 * スクロール位置がトップかどうかを判定するuse
 * @returns {{isScrollTop: boolean}}
 */
const useIsScrollTopDetect = () => {
    const initialIsScrollTop = useMemo(() => {
        const { scrollTop } = document.documentElement;
        return scrollTop === 0;
    }, []);
    const ref = useRef(initialIsScrollTop);
    const [isScrollTop, changeIsScrollTop] = useState(initialIsScrollTop);
    useEffect(() => {
        // スクロールイベントの設定
        const no = ScrollListener.setListener((offset) => {
            const isTop = offset === 0;
            if (ref.current === isTop) {
                return;
            }
            ref.current = isTop;
            changeIsScrollTop(isTop);
        });
        return () => {
            ScrollListener.deleteListener(no);
        };
    }, [changeIsScrollTop, initialIsScrollTop, ref]);
    return {
        isScrollTop,
    };
};
export const useIsScrollTop = {
    useIsScrollTopDetect,
};
export default useIsScrollTop;
